"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgPinOn = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_PIN-ON", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M6.8 6.87 6.29 7.997H9.74L9.2 6.87 10.661 2H5.339l1.462 4.87Zm5.64 2.425a.507.507 0 0 1-.469.7H9l-.46 5.499a.54.54 0 0 1-1.08 0l-.462-5.498H4.059a.507.507 0 0 1-.469-.7l1.091-2.531-1.638-5.459A1.015 1.015 0 0 1 4.016 0h7.968c.68 0 1.168.655.973 1.306l-1.638 5.459 1.121 2.53Z" }))); };
exports.default = SvgPinOn;
